module.exports = __webpack_public_path__ + "img/jiaju1.240ddac1.png";